// @flow
// Import modules
import React, { Component } from 'react';
import ClassNames from 'classnames';
import { Button } from '@riseart/common';
import { FormCheckbox, FormCheckboxGroup } from '@riseart/form';

// Import styles
import {
  quizQuestionCls,
  quizQuestionTextCls,
  quizQuestionButtonCls,
  quizQuestionButtonBackCls,
  quizQuestionButtonNextCls,
  quizQuestionOverlayCls,
  quizQuestionActiveCls,
} from './Question.less';

import {
  quizMultiSelectQuestionCheckboxCls,
  quizMultiSelectQuestionHintCls,
  quizMultiSelectQuestionCheckboxCheckedCls,
} from './MultiSelect.less';

type Props = {
  text: string,
  hintText: string,
  isValid: boolean,
  options: Array<Object>,
  onChange: Function,
  backButton: {
    translationText: string,
    url: string,
    backListener: Function,
  },
  nextButton: {
    translationText: string,
    url: string,
    nextListener: Function,
  },
  onAnswer: Function,
  error: Object,
  isActive: boolean,
  id: string,
  type: string,
};

type State = {
  selectedValues: Array<Object>,
};

/**
 * Quiz Multi Select Question
 *
 * @param {Props} props
 * @returns {XML}
 */

class QuizMultiSelectQuestion extends Component<Props, State> {
  /**
   * constructor
   *
   * @param {*} props
   */
  constructor(props: void) {
    super(props);

    this.bindMethods();
    this.state = this.getDefaultState();
  }

  /**
   * getDefaultState
   */
  getDefaultState() {
    return {
      selectedValues: [],
    };
  }

  /**
   * bindMethods
   */
  bindMethods() {
    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * handleChange
   * @param {Array<Object>} values
   */
  handleChange: Function;

  handleChange(values: Array<Object>) {
    this.setState({ selectedValues: values || [] });
    const { id, type } = this.props;
    this.props.onChange({ id, type }, values);
  }

  render() {
    const tabIndex = this.props.isActive ? '0' : '-1';

    return (
      <div
        className={ClassNames(quizQuestionCls, {
          [quizQuestionActiveCls]: this.props.isActive,
        })}
      >
        <div className={quizQuestionOverlayCls} />
        <div className={quizQuestionTextCls}>{this.props.text}</div>
        <div className={quizMultiSelectQuestionHintCls}>{this.props.hintText}</div>
        <div className={quizMultiSelectQuestionCheckboxCls}>
          <FormCheckboxGroup onChange={this.handleChange}>
            {this.props.options.map((item) => (
              <FormCheckbox
                tabIndex={tabIndex}
                className={ClassNames({
                  [quizMultiSelectQuestionCheckboxCheckedCls]:
                    this.state.selectedValues.indexOf(item.id) !== -1,
                })}
                key={item.id}
                value={item.id}
              >
                {item.text}
              </FormCheckbox>
            ))}
          </FormCheckboxGroup>
        </div>
        <div className={quizQuestionButtonCls}>
          {this.props.backButton ? (
            <Button
              className={quizQuestionButtonBackCls}
              type="text"
              noBorder
              tabIndex={tabIndex}
              disabled={false}
              onClick={this.props.backButton.backListener}
            >
              {this.props.backButton.translationText}
            </Button>
          ) : null}

          {this.props.nextButton ? (
            <Button
              className={quizQuestionButtonNextCls}
              type="black"
              isBlackBorder
              tabIndex={tabIndex}
              disabled={this.props.isValid}
              onClick={this.props.nextButton.nextListener}
            >
              {this.props.nextButton.translationText}
            </Button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default QuizMultiSelectQuestion;
